import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../types';
import { WaitingApplication, WaitingApplicationState } from './types';
import * as types from './mutation-types';

// 申請待ちのエラーをクリアする
const resetChangesAllErrors = (state: WaitingApplicationState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const destroyState = state.destroy;
    destroyState.error = false;
    destroyState.errorTitle = undefined;
    destroyState.errorDetails = undefined;
};

export const mutations: MutationTree<WaitingApplicationState> = {
    // 申請待ち一覧系
    [types.SEARCH_START](state) {
        resetChangesAllErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; waiting_applications: Array<WaitingApplication> }) {
        state.waitingApplicationCount = payload.count;
        state.waitingApplications = payload.waiting_applications;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // 申請待ち削除系
    [types.DESTROY_START](state) {
        resetChangesAllErrors(state);
        const destroyState = state.destroy;
        destroyState.isProcessing = true;
    },

    [types.DESTROY_SUCCESS](state) {
        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.DESTROY_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const destroyState = state.destroy;
        destroyState.errorTitle = payload.errorTitle;
        destroyState.errorDetails = payload.errorDetails;
        destroyState.error = true;
        destroyState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetChangesAllErrors(state);
        state.waitingApplications = undefined;
        state.waitingApplicationCount = 0;
    },
};
